import {
  JOB_FIELD_OPTIONS,
  JOB_DATA_FILTER_OPTIONS,
  JOB_SEARCH_BY_OPTIONS
} from "../../components/Jobs/constants";

export const initialState = {
  modalOpen: false,

  selectedJobs: [],
  selectedFields: JOB_FIELD_OPTIONS.reduce(
    (acc, f) => ({ ...acc, [f.key]: true }),
    {}
  ),
  searchBy: JOB_SEARCH_BY_OPTIONS[0],
  dataFilters: JOB_DATA_FILTER_OPTIONS.reduce(
    (acc, f) => ({ ...acc, [f.key]: false }),
    {}
  ),
  searchInput: "",
  searchResults: [],
  isSearching: false,
  dropdownOpen: false,
  dragIndex: null,
  dragOverIdx: null,
  // null = use the default accent (the company branding when saved); set once the user picks one.
  accentColor: null,

  step: 1,
  columnsPerRow: 2,
  rowGroups: [],
  drag2: null,
  drag2OverRow: null
};
